<script>
  let { assetsPath = '/', onAiMounted = () => {} } = $props();
  import { onMount } from 'svelte';
  onMount(() => {
    onAiMounted();
  });
</script>

<div id="g-p3_fordow-box">
  <!-- Artboard: xs -->
  <div
    id="g-p3_fordow-xs"
    class="g-artboard"
    style="display: none;aspect-ratio: 0.31730769230769;"
  >
    <div
      id="g-p3_fordow-xs-img"
      class="g-aiImg"
      alt=""
      style="background-image: url({assetsPath.replace(
        new RegExp('/([^/.]+)$'),
        '/$1/'
      ) || '/'}images/graphics/p3_fordow-xs.jpg);"
    ></div>
    <div
      id="g-ai0-1"
      class="g-text g-aiAbs g-aiPointText"
      style="top:4.1825%;margin-top:-7.5px;left:19.9877%;width:59px;"
    >
      <p class="g-pstyle0">Fordow</p>
    </div>
    <div
      id="g-ai0-2"
      class="g-text g-aiAbs g-aiPointText"
      style="top:6.0094%;margin-top:-7.5px;left:23.5364%;margin-left:-28px;width:56px;"
    >
      <p class="g-pstyle1">IRAN</p>
    </div>
    <div
      id="g-ai0-3"
      class="g-shadow g-aiAbs g-aiPointText"
      style="top:25.7289%;margin-top:-7.6px;left:61.5386%;width:122px;"
    >
      <p class="g-pstyle2">Tunnels entrance</p>
    </div>
    <div
      id="g-ai0-4"
      class="g-shadow g-aiAbs g-aiPointText"
      style="top:27.5599%;margin-top:-15.6px;left:10.2698%;width:118px;"
    >
      <p class="g-pstyle3">Subterranean</p>
      <p class="g-pstyle3">nuclear facility</p>
    </div>
    <div
      id="g-ai0-5"
      class="g-text g-aiAbs g-aiPointText"
      style="top:32.3155%;margin-top:-7.1px;left:93.1951%;margin-left:-16px;width:32px;"
    >
      <p class="g-pstyle4">N</p>
    </div>
    <div
      id="g-ai0-6"
      class="g-text g-aiAbs g-aiPointText"
      style="transform: matrix(0.7756,0.6312,-0.8319,0.5549,0,0);transform-origin: 50% 57.061338482226%;-webkit-transform: matrix(0.7756,0.6312,-0.8319,0.5549,0,0);-webkit-transform-origin: 50% 57.061338482226%;-ms-transform: matrix(0.7756,0.6312,-0.8319,0.5549,0,0);-ms-transform-origin: 50% 57.061338482226%;top:42.7962%;margin-top:-7.1px;left:11.7031%;margin-left:-29px;width:58px;"
    >
      <p class="g-pstyle5">100 m</p>
    </div>
    <div
      id="g-ai0-7"
      class="g-text g-aiAbs"
      style="top:46.8269%;left:-0.1608%;width:70.9091%;"
    >
      <p class="g-pstyle6">Centrifuge cascades</p>
      <p>
        Interconnected machines that enrich uranium by spinning uranium gas at
        high speeds.
      </p>
    </div>
    <div
      id="g-ai0-8"
      class="g-text g-aiAbs g-aiPointText"
      style="top:68.6136%;margin-top:-16.6px;left:63.4642%;width:136px;"
    >
      <p class="g-pstyle7">Ventilation and</p>
      <p class="g-pstyle7">service support hall</p>
    </div>
    <div
      id="g-ai0-9"
      class="g-text g-aiAbs g-aiPointText"
      style="top:90.6328%;margin-top:-8.6px;left:66.5392%;width:122px;"
    >
      <p class="g-pstyle7">Tunnels entrance</p>
    </div>
    <div
      id="g-ai0-10"
      class="g-text g-aiAbs"
      style="top:96.4423%;left:1.0288%;width:66.0606%;"
    >
      <p class="g-pstyle8">
        A tunnel diagram of the project from the archive obtained by Israel.
      </p>
    </div>
  </div>

  <!-- Artboard: sm -->
  <div
    id="g-p3_fordow-sm"
    class="g-artboard"
    style="display: none;aspect-ratio: 0.59302325581395;"
  >
    <div
      id="g-p3_fordow-sm-img"
      class="g-aiImg"
      alt=""
      style="background-image: url({assetsPath.replace(
        new RegExp('/([^/.]+)$'),
        '/$1/'
      ) || '/'}images/graphics/p3_fordow-sm.jpg);"
    ></div>
    <div
      id="g-ai1-1"
      class="g-text g-aiAbs g-aiPointText"
      style="top:4.1277%;margin-top:-7.5px;left:8.4048%;width:59px;"
    >
      <p class="g-pstyle0">Fordow</p>
    </div>
    <div
      id="g-ai1-2"
      class="g-text g-aiAbs g-aiPointText"
      style="top:6.337%;margin-top:-7.5px;left:10.701%;margin-left:-28px;width:56px;"
    >
      <p class="g-pstyle1">IRAN</p>
    </div>
    <div
      id="g-ai1-3"
      class="g-shadow g-aiAbs g-aiPointText"
      style="top:24.738%;margin-top:-16.7px;left:4.2063%;width:137px;"
    >
      <p class="g-pstyle2">Subterranean</p>
      <p class="g-pstyle2">nuclear facility</p>
    </div>
    <div
      id="g-ai1-4"
      class="g-shadow g-aiAbs g-aiPointText"
      style="top:25.8911%;margin-top:-8.7px;left:61.3362%;width:136px;"
    >
      <p class="g-pstyle3">Tunnels entrance</p>
    </div>
    <div
      id="g-ai1-5"
      class="g-text g-aiAbs g-aiPointText"
      style="top:38.5559%;margin-top:-7.6px;left:4.9161%;margin-left:-16px;width:32px;"
    >
      <p class="g-pstyle4">N</p>
    </div>
    <div
      id="g-ai1-6"
      class="g-text g-aiAbs"
      style="top:44.7674%;left:62.3356%;width:31.7647%;"
    >
      <p>
        <span class="g-cstyle0">Centrifuge cascades</span> Interconnected machines
        that enrich uranium by spinning uranium gas at high speeds.
      </p>
    </div>
    <div
      id="g-ai1-7"
      class="g-text g-aiAbs g-aiPointText"
      style="transform: matrix(0.7756,0.6312,-0.8319,0.5549,0,0);transform-origin: 50% 56.595600785804%;-webkit-transform: matrix(0.7756,0.6312,-0.8319,0.5549,0,0);-webkit-transform-origin: 50% 56.595600785804%;-ms-transform: matrix(0.7756,0.6312,-0.8319,0.5549,0,0);-ms-transform-origin: 50% 56.595600785804%;top:48.7885%;margin-top:-7.6px;left:25.6055%;margin-left:-29px;width:58px;"
    >
      <p class="g-pstyle5">100 m</p>
    </div>
    <div
      id="g-ai1-8"
      class="g-text g-aiAbs g-aiPointText"
      style="top:66.584%;margin-top:-19.6px;left:45.4215%;width:144px;"
    >
      <p class="g-pstyle6">Ventilation and</p>
      <p class="g-pstyle6">service support hall</p>
    </div>
    <div
      id="g-ai1-9"
      class="g-text g-aiAbs g-aiPointText"
      style="top:83.9677%;margin-top:-10.1px;left:65.0117%;width:129px;"
    >
      <p class="g-pstyle6">Tunnels entrance</p>
    </div>
    <div
      id="g-ai1-10"
      class="g-text g-aiAbs"
      style="top:94.7674%;left:42.0846%;width:42.7451%;"
    >
      <p class="g-pstyle7">
        A tunnel diagram of the project from the archive obtained by Israel.
      </p>
    </div>
  </div>

  <!-- Artboard: md -->
  <div
    id="g-p3_fordow-md"
    class="g-artboard"
    style="display: none;aspect-ratio: 0.75;"
  >
    <div
      id="g-p3_fordow-md-img"
      class="g-aiImg"
      alt=""
      style="background-image: url({assetsPath.replace(
        new RegExp('/([^/.]+)$'),
        '/$1/'
      ) || '/'}images/graphics/p3_fordow-md.jpg);"
    ></div>
    <div
      id="g-ai2-1"
      class="g-text g-aiAbs g-aiPointText"
      style="top:4.7157%;margin-top:-7.5px;left:7.7135%;width:59px;"
    >
      <p class="g-pstyle0">Fordow</p>
    </div>
    <div
      id="g-ai2-2"
      class="g-text g-aiAbs g-aiPointText"
      style="top:6.8748%;margin-top:-7.5px;left:9.4879%;margin-left:-28px;width:56px;"
    >
      <p class="g-pstyle1">IRAN</p>
    </div>
    <div
      id="g-ai2-3"
      class="g-shadow g-aiAbs g-aiPointText"
      style="top:24.403%;margin-top:-16.7px;left:14.9134%;width:137px;"
    >
      <p class="g-pstyle2">Subterranean</p>
      <p class="g-pstyle2">nuclear facility</p>
    </div>
    <div
      id="g-ai2-4"
      class="g-shadow g-aiAbs g-aiPointText"
      style="top:25.4163%;margin-top:-8.7px;left:59.0592%;width:136px;"
    >
      <p class="g-pstyle3">Tunnels entrance</p>
    </div>
    <div
      id="g-ai2-5"
      class="g-text g-aiAbs g-aiPointText"
      style="top:37.7933%;margin-top:-7.6px;left:15.4619%;margin-left:-16px;width:32px;"
    >
      <p class="g-pstyle4">N</p>
    </div>
    <div
      id="g-ai2-6"
      class="g-text g-aiAbs g-aiPointText"
      style="transform: matrix(0.7756,0.6312,-0.8319,0.5549,0,0);transform-origin: 50% 56.5953883807806%;-webkit-transform: matrix(0.7756,0.6312,-0.8319,0.5549,0,0);-webkit-transform-origin: 50% 56.5953883807806%;-ms-transform: matrix(0.7756,0.6312,-0.8319,0.5549,0,0);-ms-transform-origin: 50% 56.5953883807806%;top:47.7933%;margin-top:-7.6px;left:31.449%;margin-left:-29px;width:58px;"
    >
      <p class="g-pstyle5">100 m</p>
    </div>
    <div
      id="g-ai2-7"
      class="g-text g-aiAbs"
      style="top:53.4091%;left:0.3041%;width:24.5455%;"
    >
      <p>
        <span class="g-cstyle0">Centrifuge cascades</span> Interconnected machines
        that enrich uranium by spinning uranium gas at high speeds.
      </p>
    </div>
    <div
      id="g-ai2-8"
      class="g-text g-aiAbs"
      style="top:56.7045%;left:64.715%;width:34.0909%;"
    >
      <p>
        A tunnel diagram of the project from the archive obtained by Israel.
      </p>
    </div>
    <div
      id="g-ai2-9"
      class="g-text g-aiAbs g-aiPointText"
      style="top:73.2667%;margin-top:-14.7px;left:45.8586%;width:152px;"
    >
      <p class="g-pstyle6">Ventilation and</p>
      <p class="g-pstyle6">service support hall</p>
    </div>
    <div
      id="g-ai2-10"
      class="g-text g-aiAbs g-aiPointText"
      style="top:92.6323%;margin-top:-7.2px;left:62.7224%;width:136px;"
    >
      <p class="g-pstyle7">Tunnels entrance</p>
    </div>
  </div>

  <!-- Artboard: lg -->
  <div
    id="g-p3_fordow-lg"
    class="g-artboard"
    style="display: none;aspect-ratio: 1.10714285714286;"
  >
    <div
      id="g-p3_fordow-lg-img"
      class="g-aiImg"
      alt=""
      style="background-image: url({assetsPath.replace(
        new RegExp('/([^/.]+)$'),
        '/$1/'
      ) || '/'}images/graphics/p3_fordow-lg.jpg);"
    ></div>
    <div
      id="g-ai4-1"
      class="g-text g-aiAbs g-aiPointText"
      style="top:6.9144%;margin-top:-9.1px;left:13.2133%;width:66px;"
    >
      <p class="g-pstyle0">Fordow</p>
    </div>
    <div
      id="g-ai4-2"
      class="g-text g-aiAbs g-aiPointText"
      style="top:9.5335%;margin-top:-9.1px;left:14.503%;margin-left:-31px;width:62px;"
    >
      <p class="g-pstyle1">IRAN</p>
    </div>
    <div
      id="g-ai4-3"
      class="g-shadow g-aiAbs g-aiPointText"
      style="top:27.1176%;margin-top:-21.8px;left:23.0638%;width:146px;"
    >
      <p class="g-pstyle2">Subterranean</p>
      <p class="g-pstyle2">nuclear facility</p>
    </div>
    <div
      id="g-ai4-4"
      class="g-shadow g-aiAbs g-aiPointText"
      style="top:28.495%;margin-top:-10.4px;left:59.2083%;width:146px;"
    >
      <p class="g-pstyle3">Tunnels entrance</p>
    </div>
    <div
      id="g-ai4-5"
      class="g-text g-aiAbs g-aiPointText"
      style="top:44.2954%;margin-top:-10.1px;left:21.5987%;margin-left:-16px;width:32px;"
    >
      <p class="g-pstyle4">N</p>
    </div>
    <div
      id="g-ai4-6"
      class="g-text g-aiAbs"
      style="top:44.5238%;left:76.4753%;width:22.5806%;"
    >
      <p>
        <span class="g-cstyle0">Centrifuge cascades</span> Interconnected machines
        that enrich uranium by spinning uranium gas at high speeds.
      </p>
    </div>
    <div
      id="g-ai4-7"
      class="g-text g-aiAbs g-aiPointText"
      style="transform: matrix(0.7756,0.6312,-0.8319,0.5549,0,0);transform-origin: 50% 54.9597985081856%;-webkit-transform: matrix(0.7756,0.6312,-0.8319,0.5549,0,0);-webkit-transform-origin: 50% 54.9597985081856%;-ms-transform: matrix(0.7756,0.6312,-0.8319,0.5549,0,0);-ms-transform-origin: 50% 54.9597985081856%;top:57.0335%;margin-top:-10.1px;left:35.3095%;margin-left:-29px;width:58px;"
    >
      <p class="g-pstyle5">100 m</p>
    </div>
    <div
      id="g-ai4-8"
      class="g-text g-aiAbs g-aiPointText"
      style="top:68.8836%;margin-top:-16.6px;left:64.1695%;width:144px;"
    >
      <p class="g-pstyle6">Ventilation and</p>
      <p class="g-pstyle6">service support hall</p>
    </div>
    <div
      id="g-ai4-9"
      class="g-text g-aiAbs"
      style="top:82.381%;left:9.2323%;width:24.1935%;"
    >
      <p>
        A tunnel diagram of the project from the archive obtained by Israel.
      </p>
    </div>
    <div
      id="g-ai4-10"
      class="g-text g-aiAbs g-aiPointText"
      style="top:91.4432%;margin-top:-8.1px;left:79.927%;width:129px;"
    >
      <p class="g-pstyle7">Tunnels entrance</p>
    </div>
  </div>
</div>

<!-- End ai2html - 2025-06-18 18:09 -->

<!-- Generated by ai2html v0.101.0 - 2025-06-18 18:09 -->
<!-- ai file: p3_fordow.ai -->
<style lang="scss">
  #g-p3_fordow-box,
  #g-p3_fordow-box .g-artboard {
    margin: 0 auto;
  }
  #g-p3_fordow-box p {
    margin: 0;
  }
  #g-p3_fordow-box .g-aiAbs {
    position: absolute;
  }
  #g-p3_fordow-box .g-aiImg {
    position: absolute;
    top: 0;
    display: block;
    width: 100% !important;
    height: 100%;
    background-size: contain;
    background-repeat: no-repeat;
  }
  #g-p3_fordow-box .g-aiPointText p {
    white-space: nowrap;
  }
  #g-p3_fordow-box {
    container-type: inline-size;
    @container (min-width:0px) and (max-width: 509px) {
      #g-p3_fordow-xs {
        display: block !important;
      }
    }
    @container (min-width:510px) and (max-width: 659px) {
      #g-p3_fordow-sm {
        display: block !important;
      }
    }
    @container (min-width:660px) and (max-width: 929px) {
      #g-p3_fordow-md {
        display: block !important;
      }
    }
    @container (min-width:930px) {
      #g-p3_fordow-lg {
        display: block !important;
      }
    }
  }
  #g-p3_fordow-xs {
    position: relative;
    overflow: hidden;
  }
  #g-p3_fordow-xs p {
    font-family: 'Knowledge', 'Source Sans Pro', Arial, sans-serif;
    font-weight: 400;
    line-height: 18px;
    opacity: 1;
    letter-spacing: 0em;
    font-size: 15px;
    text-align: left;
    color: rgb(64, 64, 64);
    text-transform: none;
    padding-bottom: 0;
    padding-top: 0;
    mix-blend-mode: normal;
    font-style: normal;
    height: auto;
    position: static;
  }
  #g-p3_fordow-xs .g-pstyle0 {
    line-height: 14px;
    height: 14px;
    font-size: 12px;
    color: rgb(0, 0, 0);
  }
  #g-p3_fordow-xs .g-pstyle1 {
    line-height: 14px;
    height: 14px;
    letter-spacing: 0.2em;
    font-size: 12px;
    text-align: center;
    color: rgb(122, 122, 122);
  }
  #g-p3_fordow-xs .g-pstyle2 {
    line-height: 14px;
    height: 14px;
    font-size: 14px;
    color: rgb(255, 255, 255);
  }
  #g-p3_fordow-xs .g-pstyle3 {
    font-weight: 700;
    line-height: 15px;
    height: 15px;
    color: rgb(255, 255, 255);
  }
  #g-p3_fordow-xs .g-pstyle4 {
    line-height: 13px;
    height: 13px;
    font-size: 14px;
    text-align: center;
  }
  #g-p3_fordow-xs .g-pstyle5 {
    font-weight: 300;
    line-height: 13px;
    height: 13px;
    font-size: 14px;
    text-align: center;
  }
  #g-p3_fordow-xs .g-pstyle6 {
    font-weight: 700;
  }
  #g-p3_fordow-xs .g-pstyle7 {
    line-height: 16px;
    height: 16px;
    font-size: 14px;
  }
  #g-p3_fordow-xs .g-pstyle8 {
    line-height: 17px;
    font-size: 14px;
  }
  #g-p3_fordow-sm {
    position: relative;
    overflow: hidden;
  }
  #g-p3_fordow-sm p {
    font-family: 'Knowledge', 'Source Sans Pro', Arial, sans-serif;
    font-weight: 400;
    line-height: 18px;
    opacity: 1;
    letter-spacing: 0em;
    font-size: 15px;
    text-align: left;
    color: rgb(64, 64, 64);
    text-transform: none;
    padding-bottom: 0;
    padding-top: 0;
    mix-blend-mode: normal;
    font-style: normal;
    height: auto;
    position: static;
  }
  #g-p3_fordow-sm .g-pstyle0 {
    line-height: 14px;
    height: 14px;
    font-size: 12px;
    color: rgb(0, 0, 0);
  }
  #g-p3_fordow-sm .g-pstyle1 {
    line-height: 14px;
    height: 14px;
    letter-spacing: 0.2em;
    font-size: 12px;
    text-align: center;
    color: rgb(122, 122, 122);
  }
  #g-p3_fordow-sm .g-pstyle2 {
    font-weight: 700;
    line-height: 16px;
    height: 16px;
    font-size: 18px;
    color: rgb(255, 255, 255);
  }
  #g-p3_fordow-sm .g-pstyle3 {
    line-height: 16px;
    height: 16px;
    font-size: 16px;
    color: rgb(255, 255, 255);
  }
  #g-p3_fordow-sm .g-pstyle4 {
    line-height: 14px;
    height: 14px;
    font-size: 14px;
    text-align: center;
  }
  #g-p3_fordow-sm .g-pstyle5 {
    font-weight: 300;
    line-height: 14px;
    height: 14px;
    font-size: 14px;
    text-align: center;
  }
  #g-p3_fordow-sm .g-pstyle6 {
    line-height: 19px;
    height: 19px;
  }
  #g-p3_fordow-sm .g-pstyle7 {
    line-height: 17px;
    font-size: 14px;
  }
  #g-p3_fordow-sm .g-cstyle0 {
    font-weight: 700;
  }
  #g-p3_fordow-md {
    position: relative;
    overflow: hidden;
  }
  #g-p3_fordow-md p {
    font-family: 'Knowledge', 'Source Sans Pro', Arial, sans-serif;
    font-weight: 400;
    line-height: 19px;
    opacity: 1;
    letter-spacing: 0em;
    font-size: 16px;
    text-align: left;
    color: rgb(64, 64, 64);
    text-transform: none;
    padding-bottom: 0;
    padding-top: 0;
    mix-blend-mode: normal;
    font-style: normal;
    height: auto;
    position: static;
  }
  #g-p3_fordow-md .g-pstyle0 {
    line-height: 14px;
    height: 14px;
    font-size: 12px;
    color: rgb(0, 0, 0);
  }
  #g-p3_fordow-md .g-pstyle1 {
    line-height: 14px;
    height: 14px;
    letter-spacing: 0.2em;
    font-size: 12px;
    text-align: center;
    color: rgb(122, 122, 122);
  }
  #g-p3_fordow-md .g-pstyle2 {
    font-weight: 700;
    line-height: 16px;
    height: 16px;
    font-size: 18px;
    color: rgb(255, 255, 255);
  }
  #g-p3_fordow-md .g-pstyle3 {
    line-height: 16px;
    height: 16px;
    color: rgb(255, 255, 255);
  }
  #g-p3_fordow-md .g-pstyle4 {
    line-height: 14px;
    height: 14px;
    font-size: 14px;
    text-align: center;
  }
  #g-p3_fordow-md .g-pstyle5 {
    font-weight: 300;
    line-height: 14px;
    height: 14px;
    font-size: 14px;
    text-align: center;
  }
  #g-p3_fordow-md .g-pstyle6 {
    line-height: 14px;
    height: 14px;
  }
  #g-p3_fordow-md .g-pstyle7 {
    line-height: 13px;
    height: 13px;
  }
  #g-p3_fordow-md .g-cstyle0 {
    font-weight: 700;
  }
  #g-p3_fordow-lg {
    position: relative;
    overflow: hidden;
  }
  #g-p3_fordow-lg p {
    font-family: 'Knowledge', 'Source Sans Pro', Arial, sans-serif;
    font-weight: 400;
    line-height: 19px;
    opacity: 1;
    letter-spacing: 0em;
    font-size: 16px;
    text-align: left;
    color: rgb(64, 64, 64);
    text-transform: none;
    padding-bottom: 0;
    padding-top: 0;
    mix-blend-mode: normal;
    font-style: normal;
    height: auto;
    position: static;
  }
  #g-p3_fordow-lg .g-pstyle0 {
    line-height: 17px;
    height: 17px;
    font-size: 14px;
  }
  #g-p3_fordow-lg .g-pstyle1 {
    line-height: 17px;
    height: 17px;
    letter-spacing: 0.2em;
    font-size: 14px;
    text-align: center;
    color: rgb(122, 122, 122);
  }
  #g-p3_fordow-lg .g-pstyle2 {
    font-weight: 700;
    line-height: 21px;
    height: 21px;
    font-size: 19px;
    color: rgb(255, 255, 255);
  }
  #g-p3_fordow-lg .g-pstyle3 {
    height: 19px;
    font-size: 17px;
    color: rgb(255, 255, 255);
  }
  #g-p3_fordow-lg .g-pstyle4 {
    height: 19px;
    font-size: 14px;
    text-align: center;
  }
  #g-p3_fordow-lg .g-pstyle5 {
    font-weight: 300;
    height: 19px;
    font-size: 14px;
    text-align: center;
  }
  #g-p3_fordow-lg .g-pstyle6 {
    line-height: 16px;
    height: 16px;
    font-size: 15px;
  }
  #g-p3_fordow-lg .g-pstyle7 {
    line-height: 15px;
    height: 15px;
    font-size: 15px;
  }
  #g-p3_fordow-lg .g-cstyle0 {
    font-weight: 700;
  }

  /* Custom CSS */
  .g-shadow {
    text-shadow:
      1px 1px 1px rgb(0 0 0 / 90%),
      1px -1px 1px rgb(0 0 0 / 90%),
      -1px 1px 1px rgb(0 0 0 / 90%),
      -1px -1px 1px rgb(0 0 0 / 90%);
  }
</style>
